/* eslint-disable */
// https://mobcup.net/browse/ringtones/mp3/0/downloads
const audioFile = {
  beeps: require ('@/assets/mp3/beeps.mp3'),
  games: require ('@/assets/mp3/games.mp3'),
  ring3: require ('@/assets/mp3/ring3.mp3'),
  win1: require ('@/assets/mp3/win1.mp3'),
  win2: require ('@/assets/mp3/win2.mp3')
}
/* eslint-enable */

export default {
  render() {
    return ''
  },
  props: {
    type: { type: String, default: 'fail' },
    message: String,
    confirmObj: { type: Object },
    confirm: String,
    raiseEvent: { type: Object }
    // confirmEvent: String
  },
  watch: {
    raiseEvent(event) {
      // NON riesco a scatenare un evento da codice --> passo da qui ... correggere
      this.$emit('send-event', event)
    },
    message(msg) {
      if (msg) {
        if (this.confirmObj && this.confirmObj.beepSound && audioFile[this.confirmObj.beepSound]) {
          const sound = new Audio(audioFile[this.confirmObj.beepSound])
          sound.play()
        }
        this.$toast(msg, { type: this.type, duration: (this.confirmObj && this.confirmObj.toastDuration) || 3000 })
        const event = {
          type: 'TOAST_RESET'
        }
        this.$emit('send-event', event)
      }
    },
    confirm(msg) {
      if (msg) {
        const confirmObj = this.confirmObj
        if (this.confirmObj.beepSound && audioFile[this.confirmObj.beepSound]) {
          const sound = new Audio(audioFile[this.confirmObj.beepSound])
          sound.play()
        }
        this.$dialog.confirm({
          title: this.confirmObj.title || '',
          message: msg,
          cancelButtonText: this.confirmObj.cancelText, // 'NO',
          confirmButtonText: this.confirmObj.confirmText // 'SI'
        }).then(() => {
          if (confirmObj.event) {
            const event = {
              type: 'TOAST_CONFIRM',
              value: {
                code: confirmObj.event
              }
            }
            this.$emit('send-event', event)
          } else {
            const event = {
              type: 'TOAST_RESET'
            }
            this.$emit('send-event', event)
          }
        }).catch(() => {
          // on cancel
          const event = {
            type: 'TOAST_RESET'
          }
          this.$emit('send-event', event)
        })
      }
    }
  }
}
